var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgYellowBox = function SvgYellowBox(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 37,
    viewBox: "0 0 33 37",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91872 7.90038L14.611 0.510782C15.7811 -0.170261 17.2189 -0.170261 18.389 0.510782L31.0813 7.90038C31.2974 8.02556 31.2658 8.33056 31.0408 8.43912L17.0173 15.2062C16.6905 15.3639 16.3095 15.3639 15.9827 15.2062L1.95915 8.43912C1.73419 8.33056 1.70256 8.02556 1.91872 7.90038Z",
    fill: "#01cdfb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7692 18.4524C17.7692 17.9955 18.0307 17.579 18.4422 17.3805L32.6021 10.5472C32.7563 10.4728 32.9397 10.5619 32.9636 10.7315C32.9876 10.9082 33 11.0876 33 11.2686V25.9535C33 27.3459 32.2679 28.6313 31.0813 29.3216L18.389 36.7112C18.1009 36.8786 17.7692 36.6485 17.7692 36.3154V18.4524Z",
    fill: "#01cdfb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5578 17.3805C14.9693 17.579 15.2308 17.9955 15.2308 18.4524V36.3154C15.2308 36.6485 14.8991 36.8786 14.611 36.7112L1.91872 29.3216C0.732121 28.6313 0 27.3459 0 25.9535V11.2686C0 10.8219 0.480841 10.5873 0.883106 10.7814L14.5578 17.3805Z",
    fill: "#01cdfb"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYellowBox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/YellowBox.21840425.svg";
export { ForwardRef as ReactComponent };